import React from 'react'
import './Resume.css'
import Jobs from '../../components/Jobs/Jobs'
// import resumePDF from '../../assests/images/MarHamImages/'



const Resume = () => {
  return (
    
    <div className='ResumePageContainer '>
      <div className='resume-title-link'>
      <h1>r&eacute;sum&eacute;</h1>
      <a href='/Allison_Griffin_Res.pdf' download target='_blank'>Download My Full R&eacute;sum&eacute;!</a>
      </div>
      <div className='ResumeContainer'>
        <div className='resume-page load-square-swipe'>
          <div className='resume-content'>
            <div className='ResumeHeader-Education'>
              <h2>Allison Griffin</h2>
            </div>
            <div className='line-across-page'></div>

            <div className='skills-list'>
              <h3>Education</h3>
              <div className='line-across-page'></div>
              <div className='EducationSection'>
                <p><b>Indiana University Bloomington</b> BS in Informatics </p>
                <p><b>Minors:</b><i> Web Development, Human-Centered Computing</i></p>
              </div>


            </div>
            <div className='line-across-page'></div>

            <div className='skills-list'>
              <h3>Technical Skills</h3>
              <div className='line-across-page'></div>
              <ul>
                <li><span>Languages & Frameworks:</span> HTML5, CSS3, JavaScript, React.js, PHP, Python, TypeScript</li>
                <li><span>Frontend:</span> Bootstrap, Desktop First, Mobile-First, Responsive Design, SASS</li>
                <li><span>Backend:</span> Node.js, Jinja, PHP, Python</li>
                <li><span>Database:</span> Database Design / ERDs, MS Access, MariaDB, MySQL</li>
                <li><span>Design & Prototyping:</span> Figma, Miro, Photoshop, Adobe Illustrator</li>
                <li><span>Developer Tools:</span> Git, GitHub Copilot, Codex, VS Code, Cursor, Chrome Dev Tools, Eclipse, NPM, Arduino IDE</li>
                <li><span>Technical Knowledge:</span> Operating systems (Windows, macOS, Linux), networking concepts (TCP/IP, DNS, DHCP), hardware/peripherals</li>
                <li><span>UX Methods:</span> Wireframing, prototyping, usability testing, user research</li>
              </ul>
            </div>

            <div className='line-across-page'></div>
            <div className='skills-list'>
              <h3>Work Experience</h3>
              <div className='line-across-page'></div>
            </div>
            <Jobs></Jobs>

          </div>
        </div>
        </div>
      </div>

  )
}

export default Resume